<template>
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.8239 14.125L14.7239 10.225C14.9072 10.0417 15.1406 9.95 15.4239 9.95C15.7072 9.95 15.9406 10.0417 16.1239 10.225C16.3072 10.4083 16.3989 10.6417 16.3989 10.925C16.3989 11.2083 16.3072 11.4417 16.1239 11.625L11.5239 16.225C11.4239 16.325 11.3156 16.3958 11.1989 16.4375C11.0822 16.4792 10.9572 16.5 10.8239 16.5C10.6906 16.5 10.5656 16.4792 10.4489 16.4375C10.3322 16.3958 10.2239 16.325 10.1239 16.225L5.5239 11.625C5.34057 11.4417 5.2489 11.2083 5.2489 10.925C5.2489 10.6417 5.34057 10.4083 5.5239 10.225C5.70724 10.0417 5.94057 9.95 6.2239 9.95C6.50724 9.95 6.74057 10.0417 6.9239 10.225L10.8239 14.125Z"
            fill="white" />
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M11.824 4.5L11.824 14.5L9.82397 14.5L9.82398 4.5C9.82398 3.94772 10.2717 3.5 10.824 3.5C11.3763 3.5 11.824 3.94772 11.824 4.5Z"
              fill="white" />
    </svg>
</template>
<script>
export default {
    name: "ArrowDownIcon",
};
</script>